module.exports = __webpack_public_path__ + "media/images/sort_asc_disabled-07c018ae0160704a329067ec7fbdc614.png";